import moment from "moment";

export const fileNameWithDateTime = (prefix: string, dateTime: moment.Moment, extension: string) => {
    return `${prefix}__${dateTime.format("DD_MM_YYYY__HH_mm")}.${extension}`;
};
